import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathControlSegmentTemplates(templateId=null) {
  if (templateId) {
      return `control/segment-templates/${templateId}`;
  } else {
      return `control/segment-templates`;
  }
}

export function createControlSegmentTemplates(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlSegmentTemplates(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlSegmentTemplates(successCallback, errorCallback, data, templateId) {
  patchAuth({
    "path": pathControlSegmentTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlSegmentTemplates(successCallback, errorCallback, templateId) {
  deleteAuth({
    "path": pathControlSegmentTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderControlSegmentTemplates(successCallback, errorCallback, data, templateId) {
  postAuth({
    "path": `control/segment-templates/${templateId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewControlManageSegmentTemplates(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-segment-templates`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewControlSegmentTemplateShforms(templateId=null) {
  if (templateId) {
      return `view/control/segment-template-shforms/${templateId}`;
  } else {
      return `view/control/segment-template-shforms`;
  }
}

export function getViewControlSegmentTemplateShforms(successCallback, errorCallback, templateId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewControlSegmentTemplateShforms(templateId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
